export const VALUE_REALIZATION_DIMENSIONS = [
  "FINANCIAL_BENEFIT", "RISK_REDUCTION", "OPERATIONAL_BENEFIT",
  "STRATEGIC_QUALITATIVE_BENEFIT",
];

const unavailable = (reason = "MALFORMED_REVIEWED_CONTRACT") =>
  ({ status: "UNAVAILABLE", reason });

export function valueRealizationContextAdapter(source) {
  if (!source || source.status === "UNAVAILABLE") {
    return unavailable(source?.reason ?? "UNAVAILABLE");
  }
  if (source.status !== "AVAILABLE" || !Array.isArray(source.programs)) return unavailable();
  return {
    status: "AVAILABLE", reason: null,
    programs: source.programs.map((program) => {
      if (program?.status !== "AVAILABLE") {
        return ["NO_REVIEWED_ASSESSMENT", "UNAVAILABLE"].includes(program?.status)
          ? program : unavailable();
      }
      const keys = Object.keys(program.dimensions || {});
      if (keys.length !== 4 || !VALUE_REALIZATION_DIMENSIONS.every((key) => keys.includes(key))) {
        return { ...unavailable(), program: program.program };
      }
      return program;
    }),
  };
}
